var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

import React from "react";
import { utils } from "zebulon-controls";

// -----------------------------------------------------------
// Error management
// -----------------------------------------------------------
export var rollback = function rollback(updatedRows, index) {
  var status = updatedRows[index];
  if (!status.new_) {
    Object.keys(status.rowUpdated).forEach(function (key) {
      return status.rowUpdated[key] = null;
    });
    Object.keys(status.row).forEach(function (key) {
      return status.rowUpdated[key] = status.row[key];
    });
  }
  var n = status.errors ? status.errors.n_ || 0 : 0;
  status.deleted_ = false;
  status.updated_ = false;
  // if (!status.new_) {
  status.errors = {};
  if (updatedRows.nErrors) {
    updatedRows.nErrors -= n;
  }
  // }
};
export var rollbackAll = function rollbackAll(updatedRows, data) {
  getUpdatedRows(updatedRows).forEach(function (status) {
    if (status.new_) {
      data.splice(status.rowUpdated.index_, 1);
      delete updatedRows[status.rowUpdated.index_];
    } else if (status.updated_) {
      rollback(updatedRows, status.row.index_);
    }
  });
  delete updatedRows.nErrors;
  delete updatedRows.nErrorsServer;
  updatedRows.errors = {};
};

export var getRowStatus = function getRowStatus(updatedRows, row) {
  var status = updatedRows[row.index_];
  if (!status) {
    status = {
      // updated_: true,
      rowUpdated: row,
      row: Object.assign({}, row),
      errors: {}
    };
    updatedRows[row.index_] = status;
  }
  return status;
};
export var getUpdatedRows = function getUpdatedRows(updatedRows) {
  return Object.keys(updatedRows).filter(function (key) {
    return !Number.isNaN(Number(key)) && (updatedRows[key].deleted_ || updatedRows[key].new_ || updatedRows[key].updated_) && !(updatedRows[key].new_ && updatedRows[key].deleted_);
  }).map(function (key) {
    return updatedRows[key];
  });
};
export var setStatus = function setStatus(status, type) {
  status[type] = true;
  status.timeStamp = new Date().getTime();
};
//------------------------------------------------------------
export var manageRowError = function manageRowError(updatedRows, index, column, type, error, rowTitle, onServer) {
  var status = updatedRows[index] || {};
  if (rowTitle) {
    status.rowTitle = rowTitle;
  }
  var existsErrors = !utils.isNullOrUndefined(onServer ? status.errorsServer : status.errors);
  var errors = (onServer ? status.errorsServer : status.errors) || {};
  var existsObject = !utils.isNullOrUndefined(errors[column.id]);
  var objectErrors = errors[column.id] || {};
  var existsType = !utils.isNullOrUndefined(objectErrors[type]);
  if (error) {
    objectErrors[type] = error;
    if (!existsType) {
      objectErrors.n_ = (objectErrors.n_ || 0) + 1;
      if (!existsObject) {
        errors[column.id] = objectErrors;
      }
      errors.n_ = (errors.n_ || 0) + 1;
      if (!existsErrors) {
        if (onServer) {
          status.errorsServer = errors;
        } else {
          status.errors = errors;
        }
      }
      if (onServer) {
        updatedRows.nErrorsServer = (updatedRows.nErrorsServer || 0) + 1;
      } else {
        updatedRows.nErrors = (updatedRows.nErrors || 0) + 1;
      }
    }
  } else {
    if (existsType) {
      delete objectErrors[type];
      objectErrors.n_--;
      if (objectErrors.n_ === 0) {
        delete errors[column.id];
      }
      errors.n_--;
      if (onServer) {
        updatedRows.nErrorsServer = (updatedRows.nErrorsServer || 0) - 1;
      } else {
        updatedRows.nErrors = (updatedRows.nErrors || 0) - 1;
      }
    }
  }
};
export var getRowErrors = function getRowErrors(status, rowIndex) {
  var errors = [];
  if (!status.deleted_ && status.errors) {
    Object.keys(status.errors).forEach(function (column) {
      if (status.errors[column] || column !== "n_") {
        Object.keys(status.errors[column]).forEach(function (type) {
          if (type !== "n_") {
            errors.push({
              column: column,
              type: type,
              error: status.errors[column][type],
              rowIndex: rowIndex
            });
          }
        });
      }
    });
  }
  if (!status.deleted_ && status.errorsServer) {
    Object.keys(status.errorsServer).forEach(function (column) {
      if (status.errorsServer[column] || column !== "n_") {
        Object.keys(status.errorsServer[column]).forEach(function (type) {
          if (type !== "n_") {
            errors.push({
              column: column,
              type: type,
              error: status.errorsServer[column][type],
              rowIndex: rowIndex
            });
          }
        });
      }
    });
  }
  return errors;
};
export var getErrors = function getErrors(updatedRows) {
  var errors = [];
  if (updatedRows.errors) {
    Object.keys(updatedRows.errors).forEach(function (type) {
      if (updatedRows.errors[type].length) {
        errors.push({
          type: type,
          error: updatedRows.errors[type]
        });
      }
    });
  }
  getUpdatedRows(updatedRows).forEach(function (status) {
    if (!status.deleted_ && (status.errors || {}).n_) {
      errors = errors.concat(getRowErrors(status, status.rowUpdated.index_));
    }
  });
  return errors;
};
export var errorHandler = {
  onTableChange: function onTableChange(message) {
    if (message.type !== "sort") {
      message.modalBody = "Do you want to save before " + message.type + "?";
    }
    return true;
  },
  onSaveBefore: function onSaveBefore(message) {
    var meta = message.meta,
        updatedRows = message.updatedRows;

    var key = meta.table.lk || meta.table.pk;
    var errors = getErrors(updatedRows).map(function (error) {
      if (error.rowIndex === undefined) {
        return "\n" + (meta.table.caption || meta.table.object) + " : " + error.error;
      } else {
        var rowUpdated = updatedRows[error.rowIndex].rowUpdated;
        var rowTitle = updatedRows[error.rowIndex].rowTitle;
        if (!rowTitle && key) {
          rowTitle = key.caption + " " + rowUpdated[key.id];
        }
        return "\n" + rowTitle + " : " + error.error;
      }
    });
    if (errors.length) {
      message.modalBody = ["Can't save with errors: "].concat(errors);
      return false;
    } else {
      message.modalBody = null;
    }
    return true;
  },
  onSave: function onSave(message) {
    if (message.serverError) {
      message.modalBody = message.serverError;
      return false;
    }
    return true;
  }
};
// -----------------------------------------------------------
// Export configuration
// -----------------------------------------------------------
var excludeProperties = {
  visibleIndexes: true,
  selectItems: true,
  selectFilter: true,
  // accessorFunction: true,
  // formatFunction: true,
  // defaultFunction: true,
  // alignement: true,
  position: true,
  index_: true,
  visibleIndex_: true
};
// const hasFunction = {
//   editable: true,
//   accessor: true,
//   select: true,
//   format: true,
//   disable: true,
//   action: true,
//   onChange: true,
//   onQuit: true,
//   descriptor: true
// };
// const getItem = (key, value, parent, functions) => {
//   let v = value;
//   if (!utils.isNullOrUndefined(v) && !excludes.includes(key)) {
//     if (typeof v === "function") {
//       v: parent;
//       // manage function
//     } else if (typeof v === "function") {
//       v: parent;
//       // manage function
//     } else if (typeof v === "function") {
//       v: parent;
//       // manage function
//     }
//   }
// };
export var buildObject = function buildObject(item) {
  var excludes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : excludeProperties;

  if (Array.isArray(item)) {
    return item.map(function (item) {
      return buildObject(item);
    });
  } else if ((typeof item === "undefined" ? "undefined" : _typeof(item)) === "object") {
    return Object.keys(item).reduce(function (acc, key) {
      if (!utils.isNullOrUndefined(item[key]) && !excludes[key]) {
        acc[key] = buildObject(item[key]);
      }
      return acc;
    }, {});
  } else {
    return item;
  }
};

export var exportFunctions = function exportFunctions(functions) {
  var f = {};
  functions.forEach(function (fct) {
    if (!f[fct.visibility]) f[fct.visibility] = {};
    if (!f[fct.visibility][fct.tp]) f[fct.visibility][fct.tp] = {};
    f[fct.visibility][fct.tp][fct.id] = "~~~" + String(fct.functionJS) + "~~~";
  });
  return JSON.stringify(f).replace(/"~~~/g, "").replace(/~~~"/g, "").replace(/\\n/g, "").replace(/\\t/g, "").replace(/\\"/g, '"');
};
// ----------------------------------
// common data access (row or fiels)
// ----------------------------------
export var loadFileButton = function loadFileButton(_ref) {
  var disabled = _ref.disabled,
      index = _ref.index,
      style = _ref.style,
      onClick = _ref.onClick,
      className = _ref.className;

  var onLoad = function onLoad(e) {
    var file = document.getElementById("file-selector").files[0];
    var reader = new FileReader();
    reader.onload = function (ee) {
      onClick(Object.assign({}, ee, { file: file, text: reader.result }));
    };
    reader.readAsText(file);
  };
  return React.createElement(
    "div",
    { key: index, style: Object.assign({}, style, { display: "inherit" }) },
    React.createElement("input", {
      type: "file",
      id: "file-selector",
      onChange: onLoad,
      style: { display: "none" }
    }),
    React.createElement(
      "button",
      {
        style: { width: "inherit" },
        className: className,
        disabled: disabled,
        onClick: function onClick() {
          return document.getElementById("file-selector").click();
        }
      },
      "Load"
    )
  );
};
// -------------------------------------------
// miscelaneous
// -------------------------------------------
export var hasParent = function hasParent(element, id) {
  if (!element.parentElement) {
    return false;
  } else if (element.parentElement.id.slice(0, id.length) === id) {
    return true;
  } else {
    return hasParent(element.parentElement, id);
  }
};
export var isEqual = function isEqual(v0, v1) {
  if (v0 === v1 || utils.isDate(v0) && utils.isDate(v1) && v0.getTime() === v1.getTime() || utils.isDate(v0) && typeof v1 === "string" && v0.getTime() === new Date(v1).getTime() || utils.isDate(v1) && typeof v0 === "string" && v1.getTime() === new Date(v0).getTime() || (typeof v0 === "undefined" ? "undefined" : _typeof(v0)) === "object" && (typeof v1 === "undefined" ? "undefined" : _typeof(v1)) === "object" && Object.keys(v0).length === Object.keys(v1).length && Object.keys(v0).reduce(function (acc, key) {
    return acc && isEqual(v0[key], v1[key], true);
  })) {
    return true;
  }
  return false;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-table/lib/utils/utils.js
// module id = 13
// module chunks = 0